import React from 'react';
import { useEffect, useState, useRef } from 'react';
import LoadingPage from "../components/Loading";
import { getProfile } from '../services/users.js'
import { useNavigate, useSearchParams } from 'react-router-dom';



export default function Home(props) {
    const eventId = '68c7658ff79f0cc7cbfa00bb'
    const [data, setData] = useState({});
    const [isloading, setisloading] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || null
    const token = searchParams.get('token')  || null

    async function fetchDate() {
        if (!token) return
        setisloading(true)
        let result = await getProfile(token);
        if (result?.result) {
            setData(result.result);
        } else {
            setData({});
        }
        setisloading(false)
    }
    useEffect(() => {
       fetchDate()
    }, [token])

    function updateDynamicUrlParam(key, value) {
        searchParams.delete(key)
        if (value !== '') searchParams.set(key, value)
        setSearchParams(searchParams)
    }



    const handleBack = () => {
        //for desktop browser, navigate to home page
        if (window?.innerWidth > 768) {
            navigate('/')
            return
        }

        window?.ReactNativeWebView?.postMessage('close')
        navigate(-1)
    }


    const sectionRefInfo = useRef(null);
    const sectionRefEvent = useRef(null);
    const sectionRefTgather = useRef(null);
    const sectionRefOccupation = useRef(null);
    const sectionRefIcanx = useRef(null);
    const sectionRefU8 = useRef(null);



    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden pb-[64px]" style={{ overflow: 'auto' }}>
            <div className='w-full max-w-[800px] flex flex-col items-center justify-start relative'>
                {/*blur status bar background*/}
                <div className='w-full h-[50px] z-[10]' style={{ backgroundImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 100%)' }} />
                {/*hero image*/}
                <div className="w-full flex-col flex cursor-pointer z-[23]" onClick={() => { navigate(`/registration-form/${eventId}`) }} >
                    <img src={'https://t-gather.s3.ap-southeast-1.amazonaws.com/home/tf6.png'} className="w-full" style={{}} />
                </div>

                <div ref={sectionRefEvent} className='w-full h-[120px] mt-[-120px]' />
                <div className="w-full flex-col flex py-[16px]" >
                    <img src={'https://t-gather.s3.ap-southeast-1.amazonaws.com/home/tf4_.png'} className="w-full" style={{}} />
                </div>


                {/* <div className='w-full'>Token: {token}</div>
                <br/>
                 <div className='w-full'>Data: {JSON.stringify(data)}</div> */}
            </div>


            {/* back button, fixed at top left corner,, round, shadow */}
            <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
        </div >
    )
}
